import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslatorService } from '../core/translator/translator.service';
import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { menu } from './menu';
import { subscribermenu } from './subsciber-menu';
import { routes } from './routes';
import { consumermenu } from './consumer-menu';
import { SelectivePreloadingStrategy } from './selective-preloading.strategy';
@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: SelectivePreloadingStrategy }),
    ],
    declarations: [],
    exports: [
        RouterModule
    ]
})

export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService) {
        menuService.addMenu(menu);
        menuService.addNewMenu(subscribermenu);
        menuService.addConsumerMenu(consumermenu);
    }
}
